import React, {useContext} from 'react';
import {
  View,
  StatusBar,
  TouchableOpacity,
  Text,
  ActivityIndicator,
  StyleSheet,
} from 'react-native';

import World from 'components/World';
import worldStyle from 'style/3d';
import containerStyle from 'style/screen';
import {I18nContext} from 'i18n/context/I18nContext';
import {useSelector} from 'react-redux';

const AvatarPreviewLandscape = ({
  onLoadComplete,
  loaded,
  onLegacyFromWorld,
}) => {
  const {translate} = useContext(I18nContext);
  const customizeLocation = useSelector(state => state.world.customizeLocation);

  return (
    <View style={containerStyle.full} pointerEvents="box-none">
      <StatusBar
        backgroundColor="rgba(0, 0, 0, 0.25)"
        barStyle="light-content"
        translucent
      />
      <World
        location={customizeLocation}
        locationFilter={customizeLocation}
        onLoadComplete={onLoadComplete}
        style={worldStyle.world}
        onLegacyFromWorld={onLegacyFromWorld}
      />
      <View style={worldStyle.safeUI} pointerEvents="box-none">
        {!loaded && (
          <View style={styles.loadingOverlay} pointerEvents="none">
            <ActivityIndicator size="large" color="#fff" />
            <Text style={styles.loadingText}>
              {translate('avatarPreview.joinMeeting')}
            </Text>
          </View>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  loadingOverlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    color: '#fff',
    fontSize: 18,
    marginTop: 16,
    textAlign: 'center',
    paddingHorizontal: 20,
  },
  container: {
    flex: 1,
    alignItems: 'center',
    padding: 15,
  },
  spacer: {
    flex: 1,
  },
  joinContainer: {
    justifyContent: 'center',
    width: 150,
    paddingBottom: 20,
  },
  joinButton: {
    backgroundColor: '#fe6507',
    padding: 10,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
  },
  joinButtonText: {
    color: '#fff',
  },
});

export default AvatarPreviewLandscape;
